
export const adminLogin = (data) => ({
  type: "ADMIN_LOGIN",
  payload: data,
});
